import { gql } from '@apollo/client'

export const CLEAR_USER_LISTENING_HISTORY = gql`
  mutation clearUserListeningHistory {
    clearUserListeningHistory
  }
`
